import PropertyListComponent from "../../propertyNew/PropertyListComponent";

const PropertyCustomer = () => {

  return (  
      <PropertyListComponent
        route={`/dashboard/propertyDashboard`} 
        apiPath={`/all/property/latestList`}
        method="GET"
        requiresAuth={false}
      /> 
  ); 
};
 
export default PropertyCustomer;
